module.exports = __webpack_public_path__ + "img/Logo-1-cabecera-acuerdodepago-612_82.3d12bee7.jpg";